import React, { useEffect, useRef, useState } from 'react'
import { useOutletContext, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import { RiPagesLine } from 'react-icons/ri'
import { IoFilter } from "react-icons/io5"
import { IoAddCircleOutline, IoRemoveCircle } from 'react-icons/io5'
import moment from 'moment'

import useFetchData from 'Shared/Hooks/useFetchData'
import DataTable from 'Shared/Components/DataTable'
import { apiUrl } from 'Shared/utils'
import { FaEdit } from 'react-icons/fa'
import CameraFormModal from './components/CameraFormModal'

import FilterForm from '../FilterForm'

const CameraList = () => {
  const { setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const { send } = useFetchData()

  const tableRef = useRef()

  const filterRef = useRef({
    "project": ""
  })
  
  const [cameras, setCameras] = useState([])

  const [formOpen, setFormOpen] = useState({
    "isOpen": false,
    "camera": null,
    "mode": null
  })

  const [filterFormOpen, setFilterFormOpen] = useState(false)

  const fetchCameras = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/camera/list_by_orginization`,
      params: {
        "project": filterRef.current.project,
        "offset": (tableRef.current.getState()["page"]-1)*tableRef.current.getState()["itemsPerPage"],
        "limit": tableRef.current.getState()["itemsPerPage"]
      },
      returnType: "json"
    })

    setCameras({
      "data": body["data"].map((i) => ({
        "project": i["project"],
        "name": i["name"],
        "camera_id": i["camera_id"],
        "model": i["model"],
        "sn": i["sn"],
        "ai_enabled": i["ai_enabled"],
        "ai_enabled_display": i["ai_enabled"] ? t("general_yes") : t("general_no"),
        "url": i["url"],
        "ip": i["ip"],
        "http_port": i["http_port"],
        "usr": i["usr"],
        "pwd": i["pwd"],
      })),
      "count": Math.ceil(body["count"]/tableRef.current.getState()["itemsPerPage"])
    })
  }
  
  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await fetchCameras()

      setPageLoading(false)
    }

    init()
  }, [])

  const reloadData = async () => {
    tableRef.current.setTableLoading(true)

    await fetchCameras()

    tableRef.current.setTableLoading(false)
  }

  const onFilter = async (values) => {
    filterRef.current.project = values["project"]

    setFilterFormOpen(false)

    await reloadData()
  }

  const toggleForm = (row, mode) => {
    if (mode){
      setFormOpen({
        "isOpen": true,
        "camera": row,
        "mode": mode
      })
    }
    else {
      setFormOpen({
        "isOpen": false,
        "camera": null,
        "mode": null
      })
    }
  }

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={cameras["data"]} count={cameras["count"]} loadData={reloadData} ref={tableRef}
              columns={{
                "project": { "label": t("general_project"), "sorting": false, "nowrap": true },
                "name": { "label": t("general_deviceName"), "sorting": false, "nowrap": true },
                "model": { "label": t("cameras_model"), "sorting": false, "nowrap": true },
                "sn": { "label": t("cameras_serialNumber"), "sorting": false, "nowrap": true },
                "ip": { "label": t("cameras_ip"), "sorting": false, "nowrap": true },
                "http_port": { "label": t("cameras_httpPort"), "sorting": false, "nowrap": true },
                "ai_enabled_display": { "label": t("cameras_aiEnabled"), "sorting": false, "nowrap": true }
              }}
              appActions={() => { return [
                {icon: <IoFilter size={20}/>, text: t("general_filter"), onClick: function() { setFilterFormOpen(true) }},
                {icon: <IoAddCircleOutline size={20}/>, text: t("general_add"), onClick: function() { toggleForm(null, "Create") }}
              ]}}
              renderActions={(row) => { return [
                {icon: <RiPagesLine size={20}/>, text: t("cameras_cameraPage"), onClick: function(row) { window.open(row["url"]) }},
                {icon: <FaEdit size={20}/>, text: t("general_edit"), onClick: function(row) { toggleForm(row, "Edit") }},
                {icon: <IoRemoveCircle size={20}/>, text: t("general_remove"), onClick: function(row) { toggleForm(row, "Delete") }},
              ]}}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 

    <CameraFormModal isOpen={formOpen["isOpen"]} camera={formOpen["camera"]} mode={formOpen["mode"]} onClose={toggleForm} loadData={reloadData}/>
  
    <FilterForm filterRef={filterRef} isOpen={filterFormOpen} toggleForm={() => setFilterFormOpen(false)} onFilter={onFilter}/>
  </>)
}

export default CameraList
